import {Component} from '@angular/core';
import {AbstractIcon} from './abstract-icon';

@Component({
    selector: 'vui-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss']
})
export class IconComponent extends AbstractIcon {
}
